(function () {
  'use strict';

  const section = document.querySelector('[id^="hw-reg-"]');
  if (!section) return;

  const form = document.getElementById('hw-reg-form');
  const scheme = section.dataset.scheme;
  const apiUrl = section.dataset.apiUrl || 'https://backoffice.healthwave.ie/api/corporate-registration';

  const pages = form.querySelectorAll('.hw-reg__page');
  const dots = section.querySelectorAll('.hw-reg__step-dot');
  const globalError = document.getElementById('hw-reg-global-error');
  const successEl = document.getElementById('hw-reg-success');
  const summaryEl = document.getElementById('hw-reg-summary');
  const successDetail = document.getElementById('hw-reg-success-detail');
  const dependentsList = document.getElementById('hw-dependents-list');
  const addDependentBtn = document.getElementById('hw-add-dependent');
  const deliveryFields = document.getElementById('hw-delivery-fields');
  const submitBtn = document.getElementById('hw-reg-submit');

  let currentPage = 0;
  let dependentCount = 0;
  const MAX_DEPENDENTS = 6;

  // ── Navigation ──

  function goToPage(idx) {
    if (idx < 0 || idx >= pages.length) return;
    pages[currentPage].classList.remove('hw-reg__page--active');
    pages[idx].classList.add('hw-reg__page--active');

    dots.forEach(function (dot, i) {
      dot.classList.remove('hw-reg__step-dot--active', 'hw-reg__step-dot--done');
      if (i < idx) dot.classList.add('hw-reg__step-dot--done');
      if (i === idx) dot.classList.add('hw-reg__step-dot--active');
    });

    currentPage = idx;
    hideGlobalError();

    // Build summary on last page
    if (idx === pages.length - 1) buildSummary();

    // Scroll to top of form
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;

    var action = btn.dataset.action;
    if (action === 'next') {
      if (validatePage(currentPage)) goToPage(currentPage + 1);
    } else if (action === 'prev') {
      goToPage(currentPage - 1);
    }
  });

  // ── Validation ──

  var validators = {
    first_name: function (v) { return v.trim() ? '' : 'First name is required'; },
    last_name: function (v) { return v.trim() ? '' : 'Last name is required'; },
    date_of_birth: function (v) { return v ? '' : 'Date of birth is required'; },
    gender: function (v) { return v ? '' : 'Please select gender'; },
    email: function (v) {
      if (!v.trim()) return 'Email is required';
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? '' : 'Please enter a valid email';
    },
    billing_address_line1: function (v) { return v.trim() ? '' : 'Address is required'; },
    billing_city: function (v) { return v.trim() ? '' : 'City is required'; },
    billing_county: function (v) { return v ? '' : 'County is required'; },
    privacy_consent: function (v) { return v ? '' : 'You must accept the privacy policy'; },
  };

  // Scheme-specific validators
  if (scheme === 'garda_medical_aid' || scheme === 'pomas_scheme') {
    validators.status = function (v) { return v ? '' : 'Status is required'; };
    validators.policy_number = function (v) { return v.trim() ? '' : 'Policy number is required'; };
  }
  if (scheme === 'amazon_employee_scheme') {
    validators.coupon_code = function (v) { return v.trim() ? '' : 'Coupon code is required'; };
  }

  // Fields per page
  var pageFields = [
    // Page 0: Member details
    (function () {
      var f = ['first_name', 'last_name', 'date_of_birth', 'gender'];
      if (scheme === 'garda_medical_aid' || scheme === 'pomas_scheme') {
        f.push('status', 'policy_number');
      }
      if (scheme === 'amazon_employee_scheme') {
        f.push('coupon_code');
      }
      return f;
    })(),
    // Page 1: Contact & address
    ['email', 'billing_address_line1', 'billing_city', 'billing_county'],
    // Page 2: Family (no required fields)
    [],
    // Page 3: Terms
    ['privacy_consent'],
  ];

  function getFieldValue(name) {
    var el = form.querySelector('[name="' + name + '"]');
    if (!el) return '';
    if (el.type === 'checkbox') return el.checked;
    if (el.type === 'radio') {
      var checked = form.querySelector('[name="' + name + '"]:checked');
      return checked ? checked.value : '';
    }
    return el.value;
  }

  function showFieldError(name, msg) {
    var errEl = form.querySelector('[data-error-for="' + name + '"]');
    var input = form.querySelector('[name="' + name + '"]');
    if (errEl) errEl.textContent = msg;
    if (input && input.classList) {
      input.classList.toggle('hw-reg__input--error', !!msg);
      input.classList.toggle('hw-reg__select--error', !!msg);
    }
  }

  function validatePage(pageIdx) {
    var fields = pageFields[pageIdx] || [];
    var valid = true;

    fields.forEach(function (name) {
      var val = getFieldValue(name);
      var validator = validators[name];
      var msg = validator ? validator(val) : '';
      showFieldError(name, msg);
      if (msg) valid = false;
    });

    // Validate delivery address if page 1 and delivery != billing
    if (pageIdx === 1) {
      var sameAsBilling = getFieldValue('delivery_same_as_billing');
      if (sameAsBilling === 'false') {
        var delFields = {
          delivery_address_line1: 'Delivery address is required',
          delivery_city: 'Delivery city is required',
          delivery_county: 'Delivery county is required',
        };
        Object.keys(delFields).forEach(function (name) {
          var val = getFieldValue(name);
          var msg = val && val.trim() ? '' : delFields[name];
          showFieldError(name, msg);
          if (msg) valid = false;
        });
      }
    }

    // Validate dependent names on page 2
    if (pageIdx === 2) {
      var depCards = dependentsList.querySelectorAll('.hw-reg__dependent');
      depCards.forEach(function (card) {
        var fn = card.querySelector('[name$="_first_name"]');
        var ln = card.querySelector('[name$="_last_name"]');
        var dob = card.querySelector('[name$="_date_of_birth"]');
        if (fn && !fn.value.trim()) {
          fn.classList.add('hw-reg__input--error');
          valid = false;
        } else if (fn) {
          fn.classList.remove('hw-reg__input--error');
        }
        if (ln && !ln.value.trim()) {
          ln.classList.add('hw-reg__input--error');
          valid = false;
        } else if (ln) {
          ln.classList.remove('hw-reg__input--error');
        }
        if (dob && !dob.value) {
          dob.classList.add('hw-reg__input--error');
          valid = false;
        } else if (dob) {
          dob.classList.remove('hw-reg__input--error');
        }
      });
    }

    return valid;
  }

  // Clear error on input
  form.addEventListener('input', function (e) {
    var name = e.target.name;
    if (name) showFieldError(name, '');
    e.target.classList.remove('hw-reg__input--error', 'hw-reg__select--error');
  });

  // ── Delivery address toggle ──

  var deliveryRadios = form.querySelectorAll('[name="delivery_same_as_billing"]');
  deliveryRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      var show = this.value === 'false';
      deliveryFields.classList.toggle('hw-reg__delivery-fields--visible', show);
    });
  });

  // ── Dependents ──

  function createDependentCard(idx) {
    var card = document.createElement('div');
    card.className = 'hw-reg__dependent';
    card.dataset.depIndex = idx;
    card.innerHTML =
      '<div class="hw-reg__dependent-header">' +
        '<span class="hw-reg__dependent-title">Family Member ' + (idx + 1) + '</span>' +
        '<button type="button" class="hw-reg__remove-btn" data-remove-dep="' + idx + '">Remove</button>' +
      '</div>' +
      '<div class="hw-reg__row">' +
        '<div class="hw-reg__field">' +
          '<label class="hw-reg__label hw-reg__label--required">First Name</label>' +
          '<input class="hw-reg__input" type="text" name="dep_' + idx + '_first_name" required>' +
        '</div>' +
        '<div class="hw-reg__field">' +
          '<label class="hw-reg__label hw-reg__label--required">Last Name</label>' +
          '<input class="hw-reg__input" type="text" name="dep_' + idx + '_last_name" required>' +
        '</div>' +
      '</div>' +
      '<div class="hw-reg__row">' +
        '<div class="hw-reg__field">' +
          '<label class="hw-reg__label hw-reg__label--required">Date of Birth</label>' +
          '<input class="hw-reg__input" type="date" name="dep_' + idx + '_date_of_birth" required>' +
        '</div>' +
        '<div class="hw-reg__field">' +
          '<label class="hw-reg__label">Gender</label>' +
          '<select class="hw-reg__select" name="dep_' + idx + '_gender">' +
            '<option value="">Select…</option>' +
            '<option value="1">Male</option>' +
            '<option value="2">Female</option>' +
          '</select>' +
        '</div>' +
      '</div>';
    return card;
  }

  addDependentBtn.addEventListener('click', function () {
    if (dependentCount >= MAX_DEPENDENTS) return;
    var card = createDependentCard(dependentCount);
    dependentsList.appendChild(card);
    dependentCount++;
    if (dependentCount >= MAX_DEPENDENTS) {
      addDependentBtn.style.display = 'none';
    }
  });

  dependentsList.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-remove-dep]');
    if (!removeBtn) return;
    var card = removeBtn.closest('.hw-reg__dependent');
    if (card) {
      card.remove();
      dependentCount--;
      addDependentBtn.style.display = '';
      // Renumber remaining cards
      var cards = dependentsList.querySelectorAll('.hw-reg__dependent');
      cards.forEach(function (c, i) {
        c.querySelector('.hw-reg__dependent-title').textContent = 'Family Member ' + (i + 1);
      });
    }
  });

  // ── Summary ──

  function buildSummary() {
    var firstName = getFieldValue('first_name');
    var lastName = getFieldValue('last_name');
    var email = getFieldValue('email');
    var phone = getFieldValue('phone_number');
    var dob = getFieldValue('date_of_birth');
    var city = getFieldValue('billing_city');
    var county = getFieldValue('billing_county');

    var schemeLabels = {
      garda_medical_aid: 'Garda Medical Aid',
      pomas_scheme: 'POMAS',
      amazon_employee_scheme: 'Amazon Employee',
      an_post_scheme: 'An Post',
    };

    var html = '<strong>Scheme:</strong> ' + (schemeLabels[scheme] || scheme) + '<br>';
    html += '<strong>Name:</strong> ' + escapeHtml(firstName) + ' ' + escapeHtml(lastName) + '<br>';
    html += '<strong>DOB:</strong> ' + escapeHtml(dob) + '<br>';
    html += '<strong>Email:</strong> ' + escapeHtml(email) + '<br>';
    if (phone) html += '<strong>Phone:</strong> ' + escapeHtml(phone) + '<br>';
    html += '<strong>Location:</strong> ' + escapeHtml(city) + ', ' + escapeHtml(county) + '<br>';

    var depCards = dependentsList.querySelectorAll('.hw-reg__dependent');
    if (depCards.length > 0) {
      html += '<strong>Family Members:</strong> ' + depCards.length + '<br>';
    }

    summaryEl.innerHTML = html;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  // ── Global error ──

  function showGlobalError(msg) {
    globalError.textContent = msg;
    globalError.classList.add('hw-reg__global-error--visible');
  }

  function hideGlobalError() {
    globalError.textContent = '';
    globalError.classList.remove('hw-reg__global-error--visible');
  }

  // ── Submit ──

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validatePage(currentPage)) return;

    // Gather data
    var data = {
      scheme_name: scheme,
      first_name: getFieldValue('first_name'),
      last_name: getFieldValue('last_name'),
      email: getFieldValue('email'),
      phone_number: getFieldValue('phone_number'),
      date_of_birth: getFieldValue('date_of_birth'),
      gender: getFieldValue('gender'),
      billing_address_line1: getFieldValue('billing_address_line1'),
      billing_address_line2: getFieldValue('billing_address_line2'),
      billing_address_line3: getFieldValue('billing_address_line3'),
      billing_city: getFieldValue('billing_city'),
      billing_county: getFieldValue('billing_county'),
      billing_eircode: getFieldValue('billing_eircode'),
      delivery_same_as_billing: getFieldValue('delivery_same_as_billing') !== 'false',
      privacy_consent: true,
    };

    // Scheme-specific fields
    if (scheme === 'garda_medical_aid' || scheme === 'pomas_scheme') {
      data.policy_number = getFieldValue('policy_number');
      data.status = getFieldValue('status');
    }
    if (scheme === 'amazon_employee_scheme') {
      data.coupon_code = getFieldValue('coupon_code');
    }

    // Delivery address
    if (!data.delivery_same_as_billing) {
      data.delivery_address_line1 = getFieldValue('delivery_address_line1');
      data.delivery_address_line2 = getFieldValue('delivery_address_line2');
      data.delivery_address_line3 = getFieldValue('delivery_address_line3');
      data.delivery_city = getFieldValue('delivery_city');
      data.delivery_county = getFieldValue('delivery_county');
      data.delivery_eircode = getFieldValue('delivery_eircode');
    }

    // Dependents
    var depCards = dependentsList.querySelectorAll('.hw-reg__dependent');
    var dependents = [];
    depCards.forEach(function (card) {
      var fnInput = card.querySelector('[name$="_first_name"]');
      var lnInput = card.querySelector('[name$="_last_name"]');
      var dobInput = card.querySelector('[name$="_date_of_birth"]');
      var genderInput = card.querySelector('[name$="_gender"]');
      if (fnInput && fnInput.value.trim() && lnInput && lnInput.value.trim()) {
        dependents.push({
          first_name: fnInput.value.trim(),
          last_name: lnInput.value.trim(),
          date_of_birth: dobInput ? dobInput.value : '',
          gender: genderInput ? genderInput.value : '',
        });
      }
    });
    if (dependents.length > 0) data.dependents = dependents;

    // Disable submit
    submitBtn.disabled = true;
    submitBtn.innerHTML = '<span class="hw-reg__spinner"></span> Submitting…';
    hideGlobalError();

    fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { status: res.status, body: json };
        });
      })
      .then(function (result) {
        if (result.status === 201 || result.body.success) {
          // Success
          form.style.display = 'none';
          section.querySelector('.hw-reg__steps').style.display = 'none';
          successEl.style.display = 'block';
          var detail = 'Your member code is <strong>' + escapeHtml(result.body.memberCode) + '</strong>.';
          detail += ' You will receive a confirmation email shortly.';
          successDetail.innerHTML = detail;
        } else if (result.status === 409) {
          showGlobalError(result.body.message || 'This account is already registered.');
        } else if (result.status === 400 && result.body.details) {
          // Validation errors from Zod
          var msgs = result.body.details.map(function (d) { return d.message; }).join(', ');
          showGlobalError('Validation error: ' + msgs);
        } else {
          showGlobalError(result.body.message || 'Registration failed. Please try again.');
        }
      })
      .catch(function (err) {
        showGlobalError('Network error. Please check your connection and try again.');
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'Submit Registration';
      });
  });
})();
